import { render, staticRenderFns } from "./IconTakecredit.vue?vue&type=template&id=16798802&"
import script from "./IconTakecredit.vue?vue&type=script&lang=js&"
export * from "./IconTakecredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports